import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Airplay,
  ChevronLeft,
  DollarSign,
  Eye,
  Feather,
  Menu,
  Play,
  Target,
  Truck
} from "react-feather";
const Footer = () =>{
    const location = useLocation();
    
    const currentPath = location.pathname;


    return(
         <div className="osahan-menu-fotter fixed-bottom bg-white px-3 py-2 text-center">
          <div className="row">
            <div className="col">
              <Link
                to="/vehicleAdvance"
                className="small font-weight-bold"
                style={{
                  color:
                    currentPath === "/vehicleAdvance" ? "#004085" : "#000",
                }}
              >
                <p className="h4 m-0">
                  <Truck
                    color={
                      currentPath === "/vehicleAdvance" ? "#004085" : "#000"
                    }
                  />
                </p>
                Vehicle Advance
              </Link>
            </div>
            <div className="col">
              <Link
                to="/vendorAdvance"
                className="small font-weight-bold"
                style={{
                  color: currentPath === "/vendorAdvance" ? "#004085" : "#000",
                }}
              >
                <p className="h4 m-0">
                  <Feather
                    color={
                      currentPath === "/vendorAdvance" ? "#004085" : "#000"
                    }
                  />
                </p>
                Vendor Advance
              </Link>
            </div>
            <div className="col bg-white rounded-circle mt-n4 px-3 py-2 d-flex justify-content-center align-items-center">
              <div
                className="rounded-circle shadow d-flex justify-content-center align-items-center"
                style={{
                  width: "68px",
                  height: "68px",
                  background:
                    "linear-gradient(90deg, rgb(1, 44, 104), rgb(63, 125, 141))",
                }}
              >
                <Link
                  to="/"
                  className="d-flex justify-content-center align-items-center"
                >
                  <Airplay
                    size={32}
                    color={currentPath === "/" ? "white" : "white"}
                  />
                </Link>
              </div>
            </div>

           
            <div className="col">
              <Link
                to="/billProcess"
                className="small font-weight-bold"
                style={{
                  color:
                    currentPath === "/billProcess" ? "#004085" : "#000",
                }}
              >
                <p className="h4 m-0">
                  <Play
                    color={currentPath === "/billProcess" ? "#004085 " : "#000"}
                  />
                </p>
                Process
              </Link>
            </div>
             <div className="col">
              <Link
                to="/contractorPayment"
                className="small font-weight-bold"
                style={{
                  color: currentPath === "/billView" ? "#004085" : "#000",
                }}
              >
                <p className="h4 m-0">
                  <DollarSign
                    color={currentPath === "/contractorPayment" ? "#004085 " : "#000"}
                  />
                </p>
                Contractor Payment
              </Link>
            </div>
          </div>
        </div>
    )
}
export default Footer;